const zh = {
  // Header
  'header.nav.home': '首页',
  'header.nav.menu': '菜单',
  'header.nav.gallery': '照片',
  'header.nav.contact': '联系',
  'header.nav.changeTheme': '更换模板',
  'header.nav.changeLanguage': '更换语言',

  // Contact page
  'contact.address': '地址',
  'contact.openInGoogleMaps': '(在谷歌地图中查看)',
  'contact.contactDetails': '联系信息',
  'contact.tel': '电话',
  'contact.email': 'Email',
  'contact.pickupHours': '营业时段',
  'contact.deliveryHours': '送餐时段',
  'contact.deliveryArea': '配送区域',
  'contact.deliveryAreaNote': '*关于配送区域, 请查看以下地图',

  // Gallery
  'gallery.subTitle': 'Some of our most popular dishes ZH',
  'gallery.orderNow': 'Order Now ZH',
  'gallery.deals': 'Our Takeaway Deals',

  // Footer
  'footer.viewMenu': '查看菜单',
  'footer.termsAndConditions': '隐私政策',
  'footer.sitemap': '网站地图',
  'footer.poweredBy': 'Powered by',

  // Basket
  'basket.addToBasket': '添加 +',
  'basket.total': '总价',
  'basket.placeOrder': '去结账',
  'basket.yourOrder': '您的订单',
  'basket.emptyBasket': '您的购物车为空',
  'basket.specialInstructions': '特别需求?',
  'basket.typeHere': '在此输入...',

  // Meal
  'meal.photo.failed': '加载图片失败',
  'meal.free': '自由'
};

export default zh;



// WEBPACK FOOTER //
// ./locale/zh.js